<template>
  <span>
    Your gift will be added automatically at checkout. Minimum purchase amount does not include the purchase of
    gift card(s), tax, shipping or gift wrap charges. One gift per customer. Available while supplies last.
  </span>
</template>
